import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "@/lib/AuthProvider";

export function AdminRoute({ children }: { children: ReactNode }) {
  const auth = useAuth();
  if (!auth.ready) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        Caricamento…
      </div>
    );
  }
  if (!auth.isAdmin) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
